module.exports = __webpack_public_path__ + "img/login.af5eed20.png";